import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconYoutubeBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconYoutubeBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e4984d79b30c0a79ed04f99b5b4e836cecd16be7', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'b895318c93637f900707c9239a7281cef2e2f7a7', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '2d7d9ff8bf0b0430419eb304402d71729670ce38', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.14 6.9a2.14 2.14 0 0 0-1.5-1.51A50 50 0 0 0 11 5a50 50 0 0 0-6.64.36 2.14 2.14 0 0 0-1.5 1.54 22.7 22.7 0 0 0-.35 4.1 22.6 22.6 0 0 0 .35 4.11 2.12 2.12 0 0 0 1.5 1.51c2.202.273 4.42.4 6.64.38a50 50 0 0 0 6.64-.36 2.12 2.12 0 0 0 1.5-1.51c.243-1.363.36-2.746.35-4.13a22.7 22.7 0 0 0-.35-4.1", fill: "red" }), h("path", { key: 'ad8d4b057ee1a158031a81b7e3a723dffce3d336', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.26 13.54v-5L13.7 11z", fill: "#fff" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-youtube-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-youtube-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-youtube-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconYoutubeBranded$1);
            }
            break;
    } });
}

const CosmosIconYoutubeBranded = CosmosIconYoutubeBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconYoutubeBranded, defineCustomElement };
